/* eslint-disable import/prefer-default-export */
import { getComponentInfo } from "helpers/utilities";
import Joi from "joi";
import { useDispatch } from "react-redux";
import ResourceActions from "redux-react/actions/resourceActions";

export const useResourceActions = () => {
	const dispatch = useDispatch();

	const performAction = (data, onSuccess, onFailure) => {
		dispatch(ResourceActions.performAction(data, onSuccess, onFailure));
	};

	const insertResource = (resource, data, onSuccess, onFailure) => {
		dispatch(ResourceActions.insertResource(resource, data, onSuccess, onFailure));
	};

	const deleteResource = (resource, data, onSuccess, onFailure) => {
		dispatch(ResourceActions.deleteResource(resource, data, onSuccess, onFailure));
	};

	const updateResource = (resource, resourceID, data, onSuccess, onFailure) => {
		dispatch(ResourceActions.updateResource(resource, resourceID, data, onSuccess, onFailure));
	};

	const insertResourceEvent = (
		resource,
		resourceID,
		data,
		onSuccess = () => {},
		onFailure = () => {}
	) => {
		const { error: validationError, value } = Joi.object({
			action: Joi.string().required(),
			actor: Joi.string().required(),
			source: Joi.string().optional().default(getComponentInfo()),
			version: Joi.string().optional().default("1.0"),
			createdAt: Joi.date()
				.optional()
				.default(() => new Date()),
			payload: Joi.object().required()
		}).validate(data, { abortEarly: false });

		if (validationError) {
			onFailure(`Invalid event data: ${validationError.details.map(d => d.message).join(", ")}`);
			return;
		}

		dispatch(
			ResourceActions.insertResourceEvent(resource, resourceID, value, onSuccess, onFailure)
		);
	};

	return {
		performAction,
		insertResource,
		updateResource,
		deleteResource,
		insertResourceEvent
	};
};
